import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetUserProfileQuery } from "../rtk-query/slices/profile/profileSlice";
import { toast } from "react-toastify";

const ProtectedRoute = (props) => {
  const navigate = useNavigate();
  const { data: userProfile, isError, error } = useGetUserProfileQuery();
  if (isError) {
    if (error?.status == 401) {
      localStorage.removeItem("DODLoginToken");
      // toast.error(error?.data?.message, {
      //   position: "top-center",
      //   autoClose: 3000,
      // });
      navigate("/login");
    }
  }

  useEffect(() => {
    if (userProfile?.data) {
      if (userProfile?.data?.supplier?.on_boardings < 5) {
        navigate("/onboarding");
      } else if (window.location.pathname.includes("onboarding")) {
        navigate("/");
      } else if (userProfile?.data?.supplier?.status !== "Approved") {
        navigate("/");
      }
    }
  }, [userProfile]);

  useEffect(() => {
    if (!localStorage.getItem("DODLoginToken")) {
      navigate("/login");
    }
  }, [localStorage.getItem("DODLoginToken")]);

  return (
    <div>
      {" "}
      {React.Children.map(props.children, (child) =>
        React.cloneElement(child, {})
      )}
    </div>
  );
};

export default ProtectedRoute;
